import { Auth } from '~/amplify';

type UpdateMfaPreferenceInput = Parameters<typeof Auth.updateMFAPreference>[0];

/**
 * Cognito MFA preference changes must be followed by a backend user profile sync.
 * The changes to TOTP (Our main way of enabling MFA) must be followed by a user profile sync.
 */
const updateMfaPreferenceAndSyncUserProfile = async (
  preference: UpdateMfaPreferenceInput,
  userProfileSync: () => Promise<unknown>,
) => {
  await Auth.updateMFAPreference(preference);
  await userProfileSync();
};

export default updateMfaPreferenceAndSyncUserProfile;
